export default {
  login: {
    title: "Sign in to your account",
    footer: "Your manager creates the account and gives you the username and password. Forgot the password? Ask your manager.",
    username: "Username",
    usernamePlaceholder: "name.surname",
    password: "Password",
    submit: "Sign in",
    failed: "Could not sign in. Try again.",
  },
  twofaSetup: {
    title: "Set up two-factor authentication",
    subtitle: "2FA is required for your role. It takes a minute: scan the code with an authenticator app.",
    continue: "Continue to the platform",
    signOut: "Sign out",
    failed: "Could not start the setup.",
  },
  twofa: {
    title: "Two-factor authentication",
    subtitle: "Enter the 6-digit code from your authenticator app.",
    subtitleBackup: "Enter one of your backup codes.",
    verify: "Verify",
    useAuthenticator: "Use authenticator code",
    useBackup: "Use a backup code",
    backToSignIn: "Back to sign in",
    lostPhone: "Lost your phone? Use a backup code or ask the owner to reset 2FA.",
    failed: "Verification failed.",
    digit: "Digit {{n}}",
  },
  setPassword: {
    title: "Set your own password",
    subtitle: "You signed in with a temporary password. Choose your own to continue.",
    newPassword: "New password",
    confirm: "Confirm new password",
    ruleLength: "At least 10 characters",
    ruleMatch: "Passwords match",
    ruleDifferent: "Not the same as the temporary password",
    save: "Save and continue",
    failed: "Could not set the password.",
  },
};
